<template>

    <div class="courseComponent">

        <header :style="headerStyle">
            <h1>{{ this.data.event_name }}</h1>
        </header>

        <div class="content">

            <ul v-if="data.participants" class="participants">
                <li class="participant" v-for="participant in this.data.participants" :key="participant.name">
                    <div class="name">
                        <span>{{ participant.name }}</span>
                        <span class="online" v-if="participant.online"> (Online)</span>
                    </div>
                    <div class="company">{{ participant.company }}</div>
                </li>
            </ul>

            <div class="room">
                <div class="roomTitle">Dein Raum:</div>
                <div class="roomName">{{ this.data.room_name_new }}</div>
                <div class="roomText" v-if="data.guidanceText">{{ data.guidanceText }}</div>
                <div class="directionIcon" v-if="directionIcon">
                    <img :src="directionIcon" :class="{mirrored: directionMirrored}"/>
                </div>
                <div class="clockIcon">
                    <img v-if="data.isAfterNoonOnly" src="/img/guidance/afternoon.png"/>
                    <img v-if="data.isBeforeNoonOnly" src="/img/guidance/beforenoon.png"/>
                </div>
            </div>

        </div>

        <div v-if="data.trainer_name" class="trainer">
            <img class="trainerPhoto" :src="this.data.trainer_image_url"/>
            <div class="trainerTitle">{{ this.data.trainer_title }}</div>
            <div class="trainerName">{{ this.data.trainer_name }}</div>
        </div>

    </div>
</template>

<script>
export default {
    name: 'Course',
    props: ['data'],
    computed: {
        headerStyle() {
            return {
                background: this.data.color_background || '#eff1f3',
                color: this.data.color_text || '#1e1e1e',
            };
        },
        directionIcon() {
            if (['left', 'right'].includes(this.data.direction)) return '/img/guidance/walking.svg';
            if (['upstairs', 'downstairs'].includes(this.data.direction)) return '/img/guidance/stairs.svg';
            return null;
        },
        directionMirrored() {
            // The walking figure faces right natively; the stairs figure is
            // mirrored so it reads as ascending to the left
            return ['left', 'upstairs'].includes(this.data.direction);
        },
    },
}
</script>

<style scoped>
.courseComponent {
    box-sizing: border-box;
    height: 100%;
    background: #fff;
    position: relative;
}

header {
    box-sizing: border-box;
    height: 173px;
    margin: 0;
    padding: 0 20px;
    border-radius: 0 0 25px 25px;
    display: flex;
    align-items: center;
}

h1 {
    font-family: FamiljenGrotesk;
    font-weight: 500;
    font-size: 52px;
    line-height: 1.3;
    margin: 0;
}

.content {
    position: relative;
}

.participants {
    list-style-type: none;
    padding: 51px 0 0 46px;
    margin: 0;
    line-height: 1;
    box-sizing: border-box;
    max-width: 660px;
}

.participant {
    margin-bottom: 22px;
}

.name {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 8px;
}

.online {
    font-weight: 400;
    font-size: 26px;
}

.company {
    font-size: 23px;
    font-weight: 400;
    margin-left: 19px;
    color: #9a9a9a;
}

/* Centered on the same vertical line as the trainer photo below
   (photo center = 18px right offset + 172px/2 = 104px from panel edge) */
.room {
    position: absolute;
    font-size: 24px;
    line-height: 1;
    top: 54px;
    right: 104px;
    transform: translateX(50%);
    text-align: center;
}

.roomName {
    font-size: 30px;
    margin-top: 8px;
    font-weight: 600;
}

.directionIcon {
    margin-top: 26px;
}

.directionIcon img {
    height: 80px;
    width: auto;
}

.directionIcon img.mirrored {
    transform: scaleX(-1);
}

.roomText {
    margin-top: 8px;
    font-weight: 600;
    font-size: 24px;
}

.clockIcon {
    margin-top: 20px;
}

.trainer {
    position: absolute;
    right: 18px;
    top: 796px;
    line-height: 1;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
}

.trainerPhoto {
    width: 172px;
    height: 172px;
    object-fit: cover;
}

/* min-width equal to the photo width centers the label under the photo;
   longer text grows leftwards past the photo (right edges stay aligned) */
.trainerTitle, .trainerName {
    min-width: 172px;
    text-align: center;
    white-space: nowrap;
}

.trainerTitle {
    font-size: 24px;
    margin-top: 20px;
}

.trainerName {
    font-size: 31px;
    margin-top: 12px;
    font-weight: 600;
}
</style>
